import React from 'react'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Alert } from '@/components/ui/alert'
import { Spinner } from '@/components/ui/spinner'

export default function SendVerificationCode({
  show,
  hasError,
  error,
  loading,
  username,
  reportUsername,
  requestClose,
  requestVerificationCode
}) {
  return (
    <Dialog open={!!show} onOpenChange={o => { if (!o) requestClose() }}>
      <DialogContent onEscapeKeyDown={e => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Request Verification Code</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-3">
          {hasError && <Alert variant="error">{error}</Alert>}
          <div className="space-y-1.5">
            <Label htmlFor="vc-username">Username</Label>
            <Input
              id="vc-username"
              type="text"
              value={username || ''}
              placeholder="Your email address in all lowercase"
              onChange={e => reportUsername(e.target.value)}
            />
            <p className="text-xs text-muted-foreground">
              You'll receive a code from no-reply@aberdeen.io. Check your junk folder if it doesn't arrive.
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={requestClose}>Cancel</Button>
          <Button onClick={requestVerificationCode} disabled={loading}>
            {loading && <Spinner size={16} className="text-primary-foreground" />}
            {loading ? 'Sending…' : 'Send Code'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
